import { setUpFirebase, signInWithGoogle, signOut, updateUserInfo, getUserInfo, setupPhone, confirmPhone, checkProvider, PROVIDERS, createUserWithEmailPassword, linkWithCredential, addEmail, signInWithFacebook, signInWithTwitter, signInWithLinkedin, getCurrentUser, loginWithEmailPassword, resetPassword, changePassword } from "../../utils/firebase";
// import intlTelInput from 'intl-tel-input';
// import utils from 'intl-tel-input/build/js/utils';
import getOr from "lodash/fp/getOr";

import 'intl-tel-input/build/css/intlTelInput.css';
import { getParamUrl, validate, validateCode, validateEmail, validatePassword, validatePhone, validatePhoneEmpty } from "../../utils/utils";
import { showNeedHelpForm } from "../footer";
import { initTrack } from "../../utils/track";
import { callLoginApi, refreshToken } from "../../utils/api";
import { LocalStorage } from "../../models/LocalStorage";
import { ROOT_GLOBAL } from "../../global/root";
import Env from "../../environments";
import { GLOBAL_CONSTANTS } from "../../global/constants";
import { checkPopupUK } from "../ukPopup";

const $ = window.$;
const MIN_TIME_REFRESH_TOKEN = 1800000;
const MIN_TIME_GET_LOCATION = 86400000;

export const setUpHeader = (pageName) => {

  $(document).ready(function () {
    $(".main-body").pagefade(1000, 1000);
  });

  $(".header #page_name").text(pageName);

  setUpFlashMessage();
  setUpFirebase();
  const moreDataPhone = $(".moreInfo .data-form .phone input");
  if (moreDataPhone.length) {
    // window.phoneMore = intlTelInput(moreDataPhone[0], {
    //   initialCountry: "auto",
    //   separateDialCode: true,
    //   geoIpLookup: function (callback) {
    //     $.get('https://ipinfo.io', function () { }, "jsonp").always(function (resp) {
    //       var countryCode = (resp && resp.country) ? resp.country : "NO";
    //       callback(countryCode);
    //     });
    //   },
    //   utilsScript: utils
    // });
  }

  const loginPhone = $(".loginPhone .data-form .phone input");
  if (loginPhone.length) {
    // window.loginPhone = intlTelInput(loginPhone[0], {
    //   initialCountry: "auto",
    //   separateDialCode: true,
    //   geoIpLookup: function (callback) {
    //     $.get('https://ipinfo.io', function () { }, "jsonp").always(function (resp) {
    //       var countryCode = (resp && resp.country) ? resp.country : "NO";
    //       callback(countryCode);
    //     });
    //   },
    //   utilsScript: utils
    // });
  }

  $('.menu-toogle').on('click', function () {
    $('.menu-overlay').css("left", "0");
    document.body.style.overflowY = "hidden";
  });

  $('.menu-close').on('click', function () {
    $('.menu-overlay').css("left", "100%");
    document.body.style.overflowY = "auto";
  });

  $('.mobile-menu a').on('click', function () {
    $('.menu-overlay').css("left", "100%");
    document.body.style.overflowY = "auto";
  });

  $(".show-needhelp").on("click", function (e) {
    showNeedHelpForm(e);
  });

  $('.data-form .btn-google').on('click', function (e) {
    signInWithGoogle(function (user) {
      checkUserInfo(user, (error) => {
        loginError(error);
        signupError(error);
      });
    }, function (error) {
      console.error(error);
      loginError(error);
      signupError(error);
    });
  });

  $('.data-form .btn-facebook').on('click', function (e) {
    signInWithFacebook(function (user) {
      checkUserInfo(user, (error) => {
        loginError(error);
        signupError(error);
      });
    }, function (error) {
      console.error(error);
      loginError(error);
      signupError(error);
    });
  });

  $('.data-form .btn-twitter').on('click', function (e) {
    signInWithTwitter(function (user) {
      checkUserInfo(user, (error) => {
        loginError(error);
        signupError(error);
      });
    }, function (error) {
      console.error(error);
      loginError(error);
      signupError(error);
    });
  });

  $('.data-form .btn-linkedin').on('click', function (e) {
    signInWithLinkedin(function (user) {
      checkUserInfo(user, (error) => {
        loginError(error);
        signupError(error);
      });
    }, function (error) {
      console.error(error);
      loginError(error);
      signupError(error);
    })
  });

  $('.show-login').on("click", function (e) {
    showAuthLogin(e);
  })

  $('.show-signup').on("click", function (e) {
    showAuthSignup(e);
  })

  $('.show-loginPhone').on("click", function (e) {
    showAuthPhone(e);
  })

  $('.show-signupPhone').on("click", function (e) {
    showAuthPhone(e, true);
  })

  $('.show-loginEmail').on("click", function (e) {
    showloginEmail(e);
  })

  $('.box.moreInfo .cancel').on("click", function (e) {
    $('#authentication').modal("hide");
  });

  $('.box.moreInfo form').on("submit", function (e) {
    e && typeof e === "object" && typeof e.preventDefault === "function" && e.preventDefault();
    const email = $("#authentication .box.moreInfo .email input").val().trim();
    const password = $("#authentication .box.moreInfo .password input").val();
    const phone = window.phoneMore && window.phoneMore.getNumber();
    if (validateMoreInfo()) {
      $(this).find("[type=submit]").addClass("loading");
      const user = getCurrentUser();
      if (user) {
        if (checkProvider(user, PROVIDERS.EMAIL)) {
          moreInfoUpdateInfo(user, phone);
        } else {
          addEmail(email, password, function () {
            moreInfoUpdateInfo(user, phone);
          }, function (error) {
            moreInfoError(error);
          })
        }
      } else {
        createUserWithEmailPassword(email, password, function (user) {
          moreInfoUpdateInfo(user, phone);
        }, function (error) {
          moreInfoError(error);
        });
      }
    }
  });

  checkLogin();

  $('.box.loginPhone form').on("submit", function (e) {
    e && typeof e === "object" && typeof e.preventDefault === "function" && e.preventDefault();
    if (validateLoginPhone()) {
      $(this).find("[type=submit]").addClass("loading");
      setupPhone(window.loginPhone.getNumber(), function (confirmationResult) {
        showAuthConfirmPhone(undefined, window.loginPhone.getNumber(), confirmationResult);
      }, function (error) {
        loginPhoneError(error);
      })
    }
  });

  $('.box.confirmPhone form').on("submit", function (e) {
    e && typeof e === "object" && typeof e.preventDefault === "function" && e.preventDefault();
    if (validateConfirmPhone()) {
      $(this).find("[type=submit]").addClass("loading");
      if (window.confirmationPhoneIsLogin) {
        confirmPhone($("#authentication .box.confirmPhone .confirm-code input").val(), window.confirmationPhoneIsLogin, function (user) {
          if (user.displayName && checkProvider(user, PROVIDERS.EMAIL)) {
            showLoginDone(user, true, confirmPhoneError);
          }
        }, function (error) {
          confirmPhoneError(error);
        });
      } else {
        const credential = confirmPhone($("#authentication .box.confirmPhone .confirm-code input").val(), false);
        linkWithCredential(credential, function (user) {
          showLoginDone(user, true, confirmPhoneError);
        }, function (error) {
          confirmPhoneError(error);
        })
      }
    }
  });

  $('.box.confirmPhone .resend').on("click", function (e) {
    e && typeof e === "object" && typeof e.preventDefault === "function" && e.preventDefault();
    const button = $(this);
    button.addClass("loading");
    setupPhone(window.phoneNumberConfirming, function (confirmationResult) {
      showAuthConfirmPhone(undefined, window.phoneNumberConfirming, confirmationResult, false);
    }, function (error) {
      confirmPhoneError(error);
      button.removeClass("loading");
    });
  });

  $('.box.editProfile form').on("submit", function (e) {
    e && typeof e === "object" && typeof e.preventDefault === "function" && e.preventDefault();
    const name = $("#authentication .box.editProfile .name input").val();
    if (validateEditProfile()) {
      $(this).find("[type=submit]").addClass("loading");
      updateUserInfo({
        displayName: name
      }, function () {
        $("#authentication .box.editProfile .message").text("Update successfully.");
        $("#authentication .box.editProfile .message").removeClass("error");
        $('#authentication .box.editProfile .btn').removeClass("loading");
        showUserInfo();
        setTimeout(() => {
          $('#authentication').modal('hide');
        }, 2000);
      }, function (error) {
        editProfileError(error);
      });
    }
  });

  $('.box.changePassword form').on("submit", function (e) {
    e && typeof e === "object" && typeof e.preventDefault === "function" && e.preventDefault();
    if (validateChangePass()) {
      $(this).find("[type=submit]").addClass("loading");
      const password = $('.box.changePassword form .password input').val();
      changePassword(password, function () {
        $('.box.changePassword .message').text("Done");
        $('.box.changePassword .message').removeClass("error");
        $('.box.changePassword .btn').removeClass("loading");
        $('.box.changePassword input').val("");
        setTimeout(() => {
          $('#authentication').modal('hide');
        }, 2000);
      }, function (error) {
        changePasswordError(error);
      })
    }
  });

  $('.show-signupEmail').on("click", function (e) {
    showAuthMoreInfo();
  })

  $(".signout-link").on("click", function (e) {
    signOut(undefined, undefined, ROOT_GLOBAL.HOME_PAGE);
  })

  $('.box.loginEmail form').on("submit", function (e) {
    e && typeof e === "object" && typeof e.preventDefault === "function" && e.preventDefault();
    const email = $("#authentication .box.loginEmail .email input").val().trim();
    const password = $("#authentication .box.loginEmail .password input").val();
    if (validateLoginEmail()) {
      $(this).find("[type=submit]").addClass("loading");
      loginWithEmailPassword(email, password, function (user) {
        checkUserInfo(user, loginEmailError);
      }, function (error) {
        console.error(error);
        loginEmailError(error);
      })
    }
  });

  $('.show-resetpass').on("click", function (e) {
    showResetPass(e);
  });

  $('.box.resetPassword form').on("submit", function (e) {
    e && typeof e === "object" && typeof e.preventDefault === "function" && e.preventDefault();
    const email = $("#authentication .box.resetPassword .email input").val();
    if (validateResetPass()) {
      const submit = $(this).find("[type=submit]");
      submit.addClass("loading");
      resetPassword(email, function (user) {
        $('.box.resetPassword .message').text(`Follow the instructions sent to ${email} to recover your password`);
        $('.box.resetPassword .message').removeClass("error");
        submit.removeClass("loading");
      }, function (error) {
        console.error(error);
        resetPasswordError(error);
      })
    }
  });

  $('.form-control').on("keyup", function (e) {
    if (e.keyCode !== 13) {
      if ($(this).hasClass("is-invalid")) {
        $(this).removeClass("is-invalid");
      }
      if ($(this).parent().hasClass("is-invalid")) {
        $(this).parent().removeClass("is-invalid");
      }
    }
  });

  $('.profile-link').on("click", function (e) {
    showEditProfile(e);
  });

  $('.change-password-link').on("click", function (e) {
    showChangePass(e);
  });

  $('#authentication').on('hide.bs.modal', function (e) {
    resetAuthPopUp();
    const user = getCurrentUser();
    if (user && !checkProvider(user, PROVIDERS.EMAIL)) {
      signOut();
    }
  });
  checkToken();
  getLocation();
}

export const checkToken = () => {
  if (LocalStorage.isLoggedIn()) {
    if (LocalStorage.getTokenExpired() - Date.now() < MIN_TIME_REFRESH_TOKEN) {
      refreshToken();
    }
  }
}

export const getLocation = () => {
  const location = (LocalStorage.getLocation() + "").split("|");
  if (location.length < 2 || Date.now() - location[1] * 1 > MIN_TIME_GET_LOCATION) {
    $.get('https://ipinfo.io/json', function () { }, "json").always(function (resp) {
      const countryCode = (resp && resp.country) ? resp.country : "";
      if (countryCode) {
        LocalStorage.setLocation(`${countryCode}|${Date.now()}`);
        checkPopupUK(countryCode);
      } else {
        checkPopupUK(location[0]);
      }
    });
  } else {
    checkPopupUK(location[0]);
  }
}

export const setPage = () => {
  const page = getParamUrl("page");
  const isLoggedIn = LocalStorage.isLoggedIn();
  switch (page) {
    case "login":
      !isLoggedIn && showAuthLogin();
      break;
    case "signup":
      !isLoggedIn && showAuthSignup();
      break;
    case "needhelp":
      showNeedHelpForm();
      break;
    case "login-phone":
      !isLoggedIn && showAuthPhone(undefined, false);
      break;
    case "signup-phone":
      !isLoggedIn && showAuthPhone(undefined, true);
      break;
    case "login-email":
      !isLoggedIn && showloginEmail();
      break;
    case "signup-email":
      !isLoggedIn && showAuthMoreInfo();
      break;
    case "reset-password":
      !isLoggedIn && showResetPass();
      break;
    case "edit-profile":
      isLoggedIn && showEditProfile();
      break;
    case "change-password":
      isLoggedIn && showChangePass();
      break;
    default:
      break;
  }
}

export const checkUserInfo = (user, onError) => {
  if (user.displayName && checkProvider(user, PROVIDERS.EMAIL)) {
    showLoginDone(user, false, onError);
  }
}

export const checkLogin = () => {
  setPage();
  getUserInfo(function (user) {
    if (!$("#authentication .box.moreInfo").is(":visible") && (!user.displayName || !checkProvider(user, PROVIDERS.EMAIL))) {
      showAuthMoreInfo(user);
    }
    showUserInfo(user);
    initTrack();
    $(".main-page").addClass("loggedIn");
    $(".menu-header").fadeIn(500);
  }, function (error) {
    if ($("#authentication").hasClass('require-more-info')) {
      $("#authentication").modal('hide');
    }
    LocalStorage.inRequireLoginPaths() && LocalStorage.requireLogin();
    $(".user-box").css("display", "inline-block");
    $(".user-info-box").hide();
    if (LocalStorage.isLoggedIn()) {
      signOut();
    }
    initTrack();
    $(".main-page").removeClass("loggedIn");
    $(".menu-header").fadeIn(500);
  })
}

export const validateMoreInfo = () => {
  return validate("#authentication .box.moreInfo .email input", validateEmail) && validate("#authentication .box.moreInfo .name input") && validate("#authentication .box.moreInfo .phone .iti", validatePhoneEmpty, false, true, window.phoneMore) && validate("#authentication .box.moreInfo .password input", validatePassword);
}

export const validateEditProfile = () => {
  return validate("#authentication .box.editProfile .name input");
}

export const validateLoginEmail = () => {
  return validate("#authentication .box.loginEmail .email input", validateEmail) && validate("#authentication .box.loginEmail .password input", validatePassword);
}

export const validateLoginPhone = () => {
  return validate("#authentication .box.loginPhone .phone .iti", validatePhone, false, true, window.loginPhone);
}

export const validateChangePass = () => {
  return validate("#authentication .box.changePassword .password input", validatePassword) && validate("#authentication .box.changePassword .re-password input", validatePassword, false, true, undefined, $("#authentication .box.changePassword .password input").val());
}

export const validateConfirmPhone = () => {
  return validate("#authentication .box.confirmPhone .confirm-code input", validateCode);
}

export const validateResetPass = () => {
  return validate("#authentication .box.resetPassword .email input", validateEmail);
}

export const resetAuthPopUp = (e) => {
  e && typeof e === "object" && typeof e.preventDefault === "function" && e.preventDefault();
  resetLoginBox();
  resetSignupBox();
  resetMoreInfoBox();
  resetLoginPhoneBox();
  resetconfirmPhoneBox();
  resetSignupDone();
  resetLoginEmailBox();
  resetSignupEmailBox();
  resetLoginDone();
  resetResetPassword();
  resetEditProfile();
  resetChangePassword();

  $('#authentication .box').hide();
}

export const resetLoginBox = () => {
  resetFormBox('#authentication .box.login');
}

export const resetSignupBox = () => {
  resetFormBox('#authentication .box.signup');
}

export const resetMoreInfoBox = () => {
  resetFormBox('#authentication .box.moreInfo');
}

export const resetLoginPhoneBox = () => {
  resetFormBox('#authentication .box.loginPhone');
  $('#authentication .box.loginPhone h2').text("Login with phone number");
  $('#authentication .box.loginPhone .description').text("Enter your phone number to login.");
}

export const resetconfirmPhoneBox = () => {
  resetFormBox('#authentication .box.confirmPhone');
}

export const resetSignupDone = () => {
  resetFormBox('#authentication .box.signupDone');
}

export const resetLoginDone = () => {
  resetFormBox('#authentication .box.loginDone');
}

export const resetLoginEmailBox = () => {
  resetFormBox('#authentication .box.loginEmail');
}

export const resetSignupEmailBox = () => {
  resetFormBox('#authentication .box.moreInfo');
}

export const resetResetPassword = () => {
  resetFormBox('#authentication .box.resetPassword');
}

export const resetChangePassword = () => {
  resetFormBox('#authentication .box.changePassword');
}

export const resetEditProfile = () => {
  resetFormBox('#authentication .box.editProfile');
}

export const resetFormBox = (selector) => {
  $(selector).find('.form-control').val("");
  $(selector).find('.form-control').prop("disabled", false);
  $(selector).find('.message').text("");
  $(selector).find('.form-control').removeClass("is-invalid");
  $(selector).find('.message').removeClass("error");
  $(selector).find('.iti').removeClass("disabled");
  $(selector).find(".iti .iti__selected-flag").removeProp("tabindex");
  $(selector).find('.btn').removeClass("loading");
}

export const showAuthLogin = (e) => {
  resetAuthPopUp(e);
  $('#authentication .box.login').show();
  $('#authentication').modal('show');
}

export const showAuthSignup = (e) => {
  resetAuthPopUp(e);
  $('#authentication .box.signup').show();
  $('#authentication').modal('show');
}

export const showAuthPhone = (e, isSignup = false) => {
  resetAuthPopUp(e);
  if (isSignup) {
    $('#authentication .box.loginPhone h2').text("Signup with phone number");
    $('#authentication .box.loginPhone .description').text("Enter your phone number to create an account.");
  }
  $('#authentication .box.loginPhone').show();
  $('#authentication').modal('show');
  $('#authentication .box.loginPhone .phone input').focus();
}

export const showAuthConfirmPhone = (e, phone, confirmationResult, isLogin = true) => {
  $('#authentication .box.confirmPhone .description b').text(phone);
  window.confirmationPhoneIsLogin = isLogin;
  window.confirmationResult = confirmationResult;
  resetAuthPopUp(e);
  $('#authentication .box.confirmPhone');
  $('#authentication .box.confirmPhone').show();
  $('#authentication').modal('show');
  $('#authentication .box.confirmPhone .confirm-code input').focus();
}

export const showAuthMoreInfo = (user) => {
  resetAuthPopUp();
  const displayName = getOr("", "displayName")(user);
  const email = getOr("", "email")(user);
  const phoneNumber = getOr("", "phoneNumber")(user);
  if (displayName) {
    $('#authentication .box.moreInfo .name input').val(displayName);
  }
  if (email) {
    $('#authentication .box.moreInfo .email input').val(email);
    $('#authentication .box.moreInfo .email input').prop("disabled", true);
  }
  if (phoneNumber && window.phoneMore) {
    window.phoneMore.setNumber(phoneNumber);
    $('#authentication .box.moreInfo .phone input').prop("disabled", true);
    $('#authentication .box.moreInfo .phone .iti').addClass("disabled");
    $("#authentication .box.moreInfo .phone .iti .iti__selected-flag").prop("tabindex", -1);
  }
  if (user) {
    $('#authentication').addClass('require-more-info');
  }
  $('#authentication .box.moreInfo').show();
  $('#authentication').modal('show');
  if (!email) {
    $('#authentication .box.moreInfo .email input').focus();
  } else {
    if (!displayName) {
      $('#authentication .box.moreInfo .name input').focus();
    } else {
      if (window.phoneMore && !window.phoneMore.getNumber()) {
        $('#authentication .box.moreInfo .phone input').focus();
      } else {
        $('#authentication .box.moreInfo .password input').focus();
      }
    }
  }
}

export const showLoginDone = (user, isSignUp = false, onError, e) => {
  user.getIdToken().then(function (data) {
    let token = data;
    callLoginApi({
      access_token: token
    }, function (data) {
      if (data.isVaildAuth()) {
        data.saveLoginInfo();
        showUserInfo();
        resetAuthPopUp(e);
        $(`#authentication .box.${isSignUp ? 'signupDone' : 'loginDone'}`).show();
        $('#authentication').modal('show');
        setTimeout(() => {
          const cb = getParamUrl('cb');
          window.location.href = cb || ROOT_GLOBAL.USER_TRADE_ADVISORY;
          $('#authentication').modal('hide');
        }, 2000);
      } else {
        typeof (onError) === "function" && onError({ error_code: 'InvalidAuthToken', message: 'Invalid Authentication.' });
        signOut();
      }
    }, function (error) {
      typeof (onError) === "function" && onError(error);
      signOut();
    })
  }).catch((error) => {
    typeof (onError) === "function" && onError(error);
    signOut();
  });
}

export const showloginEmail = (e) => {
  resetAuthPopUp(e);
  $('#authentication .box.loginEmail').show();
  $('#authentication').modal('show');
  $('#authentication .box.loginEmail .email input').focus();
}

export const showResetPass = (e) => {
  resetAuthPopUp(e);
  $('#authentication .box.resetPassword').show();
  $('#authentication').modal('show');
  $('#authentication .box.resetPassword .email input').focus();
}

export const showChangePass = (e) => {
  resetAuthPopUp(e);
  $('#authentication .box.changePassword').show();
  $('#authentication').modal('show');
  $('#authentication .box.changePassword .password input').focus();
}

export const showEditProfile = (e) => {
  resetAuthPopUp(e);
  const user = getCurrentUser();
  if (user) {
    const displayName = getOr("", "displayName")(user);
    const email = getOr("", "email")(user);
    const phoneNumber = getOr("", "phoneNumber")(user);
    $('#authentication .box.editProfile .name input').val(displayName);
    $('#authentication .box.editProfile .email .value').text(email);
    if (phoneNumber) {
      $('#authentication .box.editProfile .phone').show();
      $('#authentication .box.editProfile .phone .value').text(phoneNumber);
    } else {
      $('#authentication .box.editProfile .phone').hide();
    }
    $('#authentication .box.editProfile').show();
    $('#authentication').modal('show');
    $('#authentication .box.editProfile .name input').focus();
  }
}

export const moreInfoUpdateInfo = (user, phone) => {
  updateUserInfo({
    displayName: $('.box.moreInfo .name input').val()
  }, function () {
    if (phone && !checkProvider(user, PROVIDERS.PHONE)) {
      setupPhone(phone, function (confirmationResult) {
        showAuthConfirmPhone(undefined, phone, confirmationResult, false);
      }, function (error) {
        moreInfoError(error);
      })
    } else {
      showLoginDone(user, true, moreInfoError);
    }
  }, function (error) {
    moreInfoError(error);
  });
}

export const moreInfoError = (error) => {
  $('.box.moreInfo .message').text(error && error.message ? error.message : GLOBAL_CONSTANTS.DEFAULT_ERROR);
  $('.box.moreInfo .message').addClass("error");
  $('.box.moreInfo .btn').removeClass("loading");
}

export const confirmPhoneError = (error) => {
  $('.box.confirmPhone .message').text(error && error.message ? error.message : GLOBAL_CONSTANTS.DEFAULT_ERROR);
  $('.box.confirmPhone .message').addClass("error");
  $('.box.confirmPhone .btn').removeClass("loading");
}

export const loginPhoneError = (error) => {
  console.error(error);
  $('.box.loginPhone .message').text(error && error.message ? error.message : GLOBAL_CONSTANTS.DEFAULT_ERROR);
  $('.box.loginPhone .message').addClass("error");
  $('.box.loginPhone .btn').removeClass("loading");
}

export const loginError = (error) => {
  $('.box.login .message').text(error && error.message ? error.message : GLOBAL_CONSTANTS.DEFAULT_ERROR);
  $('.box.login .message').addClass("error");
  $('.box.login .btn').removeClass("loading");
}

export const signupError = (error) => {
  $('.box.signup .message').text(error && error.message ? error.message : GLOBAL_CONSTANTS.DEFAULT_ERROR);
  $('.box.signup .message').addClass("error");
  $('.box.signup .btn').removeClass("loading");
}

export const loginEmailError = (error) => {
  $('.box.loginEmail .message').text(error && error.message ? error.message : GLOBAL_CONSTANTS.DEFAULT_ERROR);
  $('.box.loginEmail .message').addClass("error");
  $('.box.loginEmail .btn').removeClass("loading");
}

export const resetPasswordError = (error) => {
  $('.box.resetPassword .message').text(error && error.message ? error.message : GLOBAL_CONSTANTS.DEFAULT_ERROR);
  $('.box.resetPassword .message').addClass("error");
  $('.box.resetPassword .btn').removeClass("loading");
}

export const editProfileError = (error) => {
  $('.box.editProfile .message').text(error && error.message ? error.message : GLOBAL_CONSTANTS.DEFAULT_ERROR);
  $('.box.editProfile .message').addClass("error");
  $('.box.editProfile .btn').removeClass("loading");
}

export const changePasswordError = (error) => {
  $('.box.changePassword .message').text(error && error.message ? error.message : GLOBAL_CONSTANTS.DEFAULT_ERROR);
  $('.box.changePassword .message').addClass("error");
  $('.box.changePassword .btn').removeClass("loading");
}

export const showUserInfo = (user = getCurrentUser()) => {
  if (user) {
    const displayName = user.displayName;
    const email = user.email;
    // const photoURL = user.photoURL;
    // const uid = user.uid;
    // const providerData = user.providerData;

    $(".user-info-box .name").text(`${displayName || email}`);
    $(".user-info-box .name").attr('title', `${displayName || email}`);
    $(".mobile-menu .user-info-box .name").text(`Hello, ${displayName || email}`);
    $(".mobile-menu .user-info-box .name").attr('title', `Hello, ${displayName || email}`);
    $(".user-box").hide();
    $(".user-info-box").css("display", "inline-flex");
    $(".mobile-menu .user-info-box").css("display", "block");
    $('.contact-form .name input').val(displayName).trigger("change");
    $('.contact-form .email input').val(email).trigger("change");
    $('#sendtoemail .name input').val(displayName).trigger("change");
    $('#sendtoemail .email input').val(email).trigger("change");
    $("a.logo").attr("href", ROOT_GLOBAL.USER_TRADE_ADVISORY);
  } else {
    $(".user-box").show();
    $(".user-info-box").hide();
    $("a.logo").attr("href", ROOT_GLOBAL.HOME_PAGE);
  }
}

export const checkHash = () => {
  switch (window.location.hash) {
    case '#search-export':
      let element = $('.export-country select');
      if (element.length && $('.export-country select')[0].selectize) {
        $('html, body').animate({
          scrollTop: parseInt($(".section-search").offset().top)
        }, 300);
        $('.export-country select')[0].selectize.open();
      }
      break;

    default:
      break;
  }
}

export const setUpFlashMessage = () => {
  $('.flash-message .close').on('click', (e) => {
    LocalStorage.setFlashMessage(Env.DUTY_CAST_FLASH_MESSAGE);
    $('.flash-message').removeClass('active');
  });

  $('body').on('click', '.flash-message a', (e) => {
    LocalStorage.setFlashMessage(Env.DUTY_CAST_FLASH_MESSAGE);
    $('.flash-message').removeClass('active');
  });

  $(window).on('hashchange', function () {
    checkHash();
  });

  checkHash();
  try {
    let data = Env.DUTY_CAST_FLASH_MESSAGE;
    let localData = LocalStorage.getFlashMessage();
    if (data === localData) {
      return;
    }
    if (!data) {
      return;
    }
    data = atob(data);
    $('.flash-message .content').html(data);
    $('.flash-message').addClass('active');
  } catch (error) {

  }
}